import React from 'react'
import styles from './figurewithcaption.module.scss'
import Img from 'gatsby-image'

export default props => {
  const { title, sold, height, width, image } = props
  return (
    //TODO This markup is duplicated in Painting.js because I wanted different styles and couldn't figure out a good way to do it in CSS Modules
    <figure className={styles.figure}>
      <Img className={styles.img} fluid={image.childImageSharp.fluid} />
      <figcaption className={styles.figcaption}>
        <div className={styles.title}>{title}</div>
        <div className={styles.medium}>{props.medium.replace(/_/g, ' ')}</div>
        <div>
          {width} x {height}
        </div>
        <div>{sold ? 'Sold' : 'Available'}</div>
      </figcaption>
    </figure>
  )
}
